export const SET_NEW_CONTACT_BUSINESS_INFORMATION = 'SET_NEW_CONTACT_BUSINESS_INFORMATION';
export const SET_NEW_BUSINESS_INFORMATION = 'SET_NEW_BUSINESS_INFORMATION';
export const SET_NEW_OWNERSHIP_BUSINESS_INFORMATION = 'SET_NEW_OWNERSHIP_BUSINESS_INFORMATION';
export const SET_NEW_DEMPGRAPHIC_BUSINESS_INFORMATION = 'SET_NEW_DEMPGRAPHIC_BUSINESS_INFORMATION';
export const SET_NEW_DEMPGRAPHIC_BUSINESS_ADDRESS_INFORMATION = 'SET_NEW_DEMPGRAPHIC_BUSINESS_ADDRESS_INFORMATION';
export const SET_NEW_DEMPGRAPHIC_MAILING_ADDRESS_INFORMATION = 'SET_NEW_DEMPGRAPHIC_MAILING_ADDRESS_INFORMATION';
export const SET_NEW_OWNERSHIP_OWNER_INFORMATION = 'SET_NEW_OWNERSHIP_OWNER_INFORMATION';
export const SET_NEW_OWNERSHIP_OWNER_ADDRESS_INFORMATION = 'SET_NEW_OWNERSHIP_OWNER_ADDRESS_INFORMATION';
export const SET_NEW_DEPOSIT_BANK_INFORMATION = 'SET_NEW_DEPOSIT_BANK_INFORMATION';
export const SET_NEW_WITHDRAWAL_BANK_INFORMATION = 'SET_NEW_WITHDRAWAL_BANK_INFORMATION';

export const setNewBusinessContactValue = (keyName, value) => ({
  type: SET_NEW_CONTACT_BUSINESS_INFORMATION,
  keyName,
  value
});

export const setNewBusinessInformation = (keyName, value) => ({
  type: SET_NEW_BUSINESS_INFORMATION,
  keyName,
  value
});

export const setNewOwnershipBusinessInformation = (keyName, value) => ({
  type: SET_NEW_OWNERSHIP_BUSINESS_INFORMATION,
  keyName,
  value
});

export const setNewDemographicBusinessInformation = (keyName, value) => ({
  type: SET_NEW_DEMPGRAPHIC_BUSINESS_INFORMATION,
  keyName,
  value
});

export const setNewDemographicBusinessAddressInformation = (keyName, value) => ({
  type: SET_NEW_DEMPGRAPHIC_BUSINESS_ADDRESS_INFORMATION,
  keyName,
  value
});

export const setNewDemographicMailingAddressInformation = (keyName, value) => ({
  type: SET_NEW_DEMPGRAPHIC_MAILING_ADDRESS_INFORMATION,
  keyName,
  value
});

export const setNewOwnershipOwnerInformation  = (keyName, value) => ({
  type: SET_NEW_OWNERSHIP_OWNER_INFORMATION,
  keyName,
  value
});

export const setNewOwnershipOwnerAdressInformation = (keyName, value) => ({
  type: SET_NEW_OWNERSHIP_OWNER_ADDRESS_INFORMATION,
  keyName,
  value
});

export const setNewDepositBankInformation = (keyName, value) => ({
  type: SET_NEW_DEPOSIT_BANK_INFORMATION,
  keyName,
  value
});

export const setNewWithdrawalBankInformation = (keyName, value) => ({
  type: SET_NEW_WITHDRAWAL_BANK_INFORMATION,
  keyName,
  value
});
